// Imports
import React, { useEffect } from "react";
import QuizMain from "src/modules/QuizMain/jsx/index.jsx";
import { useQuiz } from "src/contexts/QuizContext.js";
import Recommendation from "../Components/recommendation.jsx";
import Splash from "../Components/splash.jsx";
const Quiz = () => {
  const { quizStatus, dispatch } = useQuiz();

  var pWrapper = document.getElementsByClassName("page-wrapper");
  const pageLock = (add = true) => {
    if (pWrapper) {
      add
        ? pWrapper[0].classList.add("locked")
        : pWrapper[0].classList.remove("locked");
    }
  };

  // check if there is a window.config.articles[] collection, populated from URL
  // if so, populate articles in state, and display recommendations page
  const checkLinkedArticles = () => {
    if (typeof window?.config?.articles !== "undefined") {
      if (window?.config?.articles?.length) {
        dispatch({
          type: "setArticles",
          payload: {
            articles: window.config.articles,
          },
        });

        /*
        This is done via context init
        dispatch({
          type: "quizStatus",
          payload: {
            value: "recommendations",
          },
        });*/
      }
    }
  };

  useEffect(() => {
    checkLinkedArticles();
  }, []);

  // set the window width
  useEffect(() => {
    const handleResize = () => {
      dispatch({
        type: "windowWidth",
        payload: {
          value: window.innerWidth,
        },
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  switch (quizStatus) {
    case "closed":
      pageLock(false);
      return <Splash />;
    case "recommendations":
      pageLock(false);
      return <Recommendation />;
    default:
      pageLock();
      return (
        <>
          <div className="micro-modal__overlay micro-modal__overlay--quiz"></div>
          <dialog
            tabIndex={0}
            className={`container quiz ${quizStatus !== "start" ? "quiz-start" : ""}`}
          >
            <QuizMain />
          </dialog>
        </>
      );
  }
};

export default Quiz;
